const API_BASE = process.env.REACT_APP_API_BASE || 'https://neurolex-api.azurewebsites.net';
//const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:5095';

const config = Object.freeze({
  apiBase: API_BASE,

  // API endpoints
  endpoints: Object.freeze({
    chat: `${API_BASE}/chat/chat`,
    spellingQuiz: `${API_BASE}/api/SpellingQuiz/generate-words`,
    addActivity: `${API_BASE}/api/StudentActivity/add-activity`,
    registerStudent: `${API_BASE}/api/StudentRegistration/upsert`,
    logActivity: `${API_BASE}/api/StudentRegistration/log-activity`,
    myActivities: `${API_BASE}/api/StudentRegistration/my-activities`,
    jsonData: (type) => `${API_BASE}/api/jsondata/${encodeURIComponent(type)}`,
    sentences: `${API_BASE}/api/jsondata/sentences`,
  }),

  // MSAL / Auth
  msal: Object.freeze({
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID || '76be5c48-20a2-4dc2-8fb5-a598290c8dc0',
    authority: process.env.REACT_APP_MSAL_AUTHORITY || 'https://lexgokidsb2c.ciamlogin.com/44028e0b-7a0c-4432-993f-b894505889e5',
    knownAuthority: process.env.REACT_APP_MSAL_KNOWN_AUTHORITY || 'lexgokidsb2c.ciamlogin.com',
  }),
});

export default config;
